export const imgTypeCheck = (type: string) => {
  return type === 'STIC' || type === 'IMAG' || type === 'GALL';
};